import en from "./en.json";
import it from "./it.json";

const common = { en, it };

export default common;
